import axios from '@/axios';
import bus from '@/bus';

export default {
    data() {
        return {
            cart: {
                id: null,
                items: [],
                brushes: [],
                collection_option: 'stay',
                collection_date: null,
                collection_time: null,
                street_number: null,
                route: null,
                suite: null,
                locality: null,
                administrative_area_level_1: null,
                postal_code: null,
                country_code: 'US',
                lat: null,
                lng: null,
                timezone: 'America/Denver',
                delivery_instructions: null,
                guest_id: null,
                customer_id: null,
                customer: {},
                studio_id: null,
                created_at: null,
                updated_at: null,
                deleted_at: null,
            },
        };
    },
    computed: {
        inStockItems() {
            return this.cart.items.filter((item) => item.isInStock);
        },
    },
    created() {
        this.cart = { ...this.entity };

        if (this.cart.brushes === null) {
            this.cart.brushes = [];
        }

        bus.$on('refresh-cart', (cart) => {
            this.cart = cart;
        });

        Echo.channel(`carts.${this.cart.id}`).listen('RefreshCart', () => {
            this.refresh();
        });
    },
    beforeDestroy() {
        bus.$off('refresh-cart');

        Echo.leave(`carts.${this.cart.id}`);
    },
    methods: {
        refresh() {
            axios.get(route('studio.shop.cart.show', { studioSlug: this.studio.slug, cart: this.cart.id })).then((response) => {
                this.cart = response.data.data;
                if (this.cart.brushes === null) {
                    this.cart.brushes = [];
                }
            });
        },
    },
};
